import { render, staticRenderFns } from "./QrDiscount.vue?vue&type=template&id=1cefeb45&scoped=true&"
import script from "./QrDiscount.vue?vue&type=script&lang=js&"
export * from "./QrDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cefeb45",
  null
  
)

export default component.exports